var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ToggleButtonGroup } from "@mui/material";
import './ButtonGroupComponent.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonGroupComponent = function (_a) { var id = _a.id, label = _a.label, children = _a.children, buttonGroupStyle = _a.buttonGroupStyle, other = __rest(_a, ["id", "label", "children", "buttonGroupStyle"]); return /*#__PURE__*/ _jsx(ToggleButtonGroup, { id: (id ? id : 'undefinedId') + 'Wrapper', "data-testid": (id ? id : 'undefinedId') + 'Wrapper', className: "btn-group btn-group-toggle ".concat(buttonGroupStyle), "aria-label": label, exclusive: true, children: children }); };
